var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (arrows, continueBtnText, doneText, hasNarration, hasPrompt, i18n, items, prompt, submitUp, undefined, written) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"content-fill slide-up\"><div class=\"carousel content-fill delay-6\"><div" + (jade.attr("style", "height: " + (items.length * 100) + "%;", true, false)) + " class=\"carousel-slider content-fill clearfix\">");
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var item = $$obj[i];

buf.push("<div" + (jade.attr("style", "height: " + (100 / items.length) + "%;", true, false)) + (jade.cls(['carousel-item','content-fill',[
            "style-" + written.hyphenCase(item.captionStyle),
            "img-pos-" + written.hyphenCase(item.imagePosition)
          ].join(" ")], [null,null,true])) + "><div" + (jade.cls(['content-fill','carousel-content',(
              item.imagePosition === "Cover" ? "full-screen" : ""
            )], [null,null,true])) + ">");
switch (item.contentType){
case "text":
buf.push("<div class=\"content-ver text-center text-md\">" + (null == (jade_interp = item.content) ? "" : jade_interp) + "</div>");
  break;
case "image":
if ( item.imagePosition === "Cover")
{
buf.push("<div" + (jade.attr("style", "background-image: url(" + (item.content) + ")", true, false)) + " class=\"img-pos-cover\"></div>");
}
else
{
jade_mixins["image"](item.content, 'img content');
}
  break;
}
buf.push("</div>");
if ( item.caption)
{
buf.push("<div" + (jade.cls(['caption','text-center','block-box-sizing',"position-" + ((item.position || 'bottom').toLowerCase()) + ""], [null,null,null,true])) + "><div class=\"caption-content text-md block-lg\">" + (null == (jade_interp = item.caption) ? "" : jade_interp) + "</div></div>");
}
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var item = $$obj[i];

buf.push("<div" + (jade.attr("style", "height: " + (100 / items.length) + "%;", true, false)) + (jade.cls(['carousel-item','content-fill',[
            "style-" + written.hyphenCase(item.captionStyle),
            "img-pos-" + written.hyphenCase(item.imagePosition)
          ].join(" ")], [null,null,true])) + "><div" + (jade.cls(['content-fill','carousel-content',(
              item.imagePosition === "Cover" ? "full-screen" : ""
            )], [null,null,true])) + ">");
switch (item.contentType){
case "text":
buf.push("<div class=\"content-ver text-center text-md\">" + (null == (jade_interp = item.content) ? "" : jade_interp) + "</div>");
  break;
case "image":
if ( item.imagePosition === "Cover")
{
buf.push("<div" + (jade.attr("style", "background-image: url(" + (item.content) + ")", true, false)) + " class=\"img-pos-cover\"></div>");
}
else
{
jade_mixins["image"](item.content, 'img content');
}
  break;
}
buf.push("</div>");
if ( item.caption)
{
buf.push("<div" + (jade.cls(['caption','text-center','block-box-sizing',"position-" + ((item.position || 'bottom').toLowerCase()) + ""], [null,null,null,true])) + "><div class=\"caption-content text-md block-lg\">" + (null == (jade_interp = item.caption) ? "" : jade_interp) + "</div></div>");
}
buf.push("</div>");
    }

  }
}).call(this);

buf.push("</div></div>");
if ( arrows)
{
buf.push("<div class=\"btn btn-muted btn-circular btn-up\"><span class=\"icon icon-chevron-up text-lg\"></span></div><div class=\"btn btn-muted btn-circular btn-down\"><span class=\"icon icon-chevron-down text-lg\"></span></div>");
}
buf.push("</div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"arrows" in locals_for_with?locals_for_with.arrows:typeof arrows!=="undefined"?arrows:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"items" in locals_for_with?locals_for_with.items:typeof items!=="undefined"?items:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"written" in locals_for_with?locals_for_with.written:typeof written!=="undefined"?written:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}